import type { PaginationState } from '@tanstack/react-table';
import { useEffect, useRef } from 'react';
import { useDebounce } from 'use-debounce';
import { DEFAULT_PAGE_INDEX } from '../lib';

export function useDebouncedSearch(
  value: string | null | undefined,
  delay: number,
  setPagination?: React.Dispatch<React.SetStateAction<PaginationState>>
): string {
  const [debouncedValue] = useDebounce(value ?? '', delay);
  const initialValue = useRef(value ?? '');
  const hasHydratedInitialValue = useRef(false);

  useEffect(() => {
    if (!hasHydratedInitialValue.current && debouncedValue === initialValue.current) {
      hasHydratedInitialValue.current = true;
      return;
    }

    if (!hasHydratedInitialValue.current) return;

    setPagination?.((prev) => ({ ...prev, pageIndex: DEFAULT_PAGE_INDEX }));
  }, [debouncedValue, setPagination]);

  return debouncedValue;
}
